




























import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';
import { SelectWings } from 'wings-ui-components';
import {Action, Getter} from 'vuex-class';
import { BlacklistItem } from '@/store/settings/blacklists/types';

@Component({
  components: { SelectWings },
})
export default class BlackListSelection extends Vue {
  @PropSync('options') propOptions!: any;
  @PropSync('blackList') blacklists!: BlacklistItem[];
  @Action('getBlacklists') actionGetBlackLists: any;

  selectedBlacklists: number | null = null;
  blackListsList: BlacklistItem[] = [];

  onDeleteChip(sel: BlacklistItem) {
    if (sel.is_public === 0) return;
    const idx = this.blacklists?.findIndex((item: BlacklistItem) => item.id === sel.id);
    if (idx > -1) this.blacklists?.splice(idx, 1)

    const optionIdx = this.propOptions.blacklist_ids.findIndex((item: BlacklistItem) => item.id === sel.id);
    if (optionIdx > -1) this.propOptions.blacklist_ids.splice(optionIdx, 1)
  }

  async getBlackList(filter: any) {
    const items = await this.actionGetBlackLists({is_public: 1, ...filter});
    this.blackListsList = filter?.page_number > 1 ? this.blackListsList.concat(items) : items;
  }

  onAddBlackList(val: number) {
    if (!val || this.blacklists?.find((item: BlacklistItem) => item.id === val)) return;
    const option = this.blackListsList.find((item: BlacklistItem) => item?.id === val);
    if (!option) return;
    this.propOptions.blacklist_ids.push(val);
    this.blacklists?.push(option);
  }
}
